<template>
  <div class="page-container users-container">
    <todo-side-bar selected="vouchers" />

    <h1>{{ $t('pages.coupons') }}</h1>

    <el-tabs v-model="activeCreateTab" @tab-click="handleClick">
      <el-tab-pane label="Create Discount/Coupons" name="create-coupon" style="height: 100%">
        <todo-create-coupon @newCoupon="ChangeT($event)" />
      </el-tab-pane>
      <el-tab-pane label="View Discount/Coupons" name="view-coupon" style="height: 100%">
        <todo-view-coupon :resetTab='resetTab' />
      </el-tab-pane>
      <el-tab-pane label="Map Coupons" name="map-coupon" style="height: 100%">
        <todo-map-coupon :loadCouponData='passdata' />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import TodoCreateCoupon from './components/CreateCoupon.vue'
  import TodoViewCoupon from './components/ViewCoupon.vue'
  import TodoMapCoupon from './components/MapCoupon.vue'
  import Vue from 'vue'
  export default {
    components: {
      'todo-create-coupon': TodoCreateCoupon,
      'todo-view-coupon': TodoViewCoupon,
      'todo-map-coupon': TodoMapCoupon
    },

    data() {
      return {
        activeCreateTab: 'create-coupon',
        passdata: {},
        bus: new Vue(),
        data: [],
        resetTab: ''
      }
    },
    methods: {
      ChangeT(title) {
        this.passdata = title
        this.activeCreateTab = 'map-coupon'
      },
      handleClick(obj, e) {
        if (obj.name === 'map-coupon') {
          this.passdata = {}
          this.activeCreateTab = 'map-coupon'
        }
        if (obj.name === 'view-coupon') {
          this.resetTab = 'true'
        } else {
          this.resetTab = 'false'
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/variables';

  .el-input{
    width:auto!important;
  }
  .el-form-item__label{
    line-height: initial!important;
  }
</style>
